import { Navbar, type NavLanguageDropdown } from '@denqfabrik/landing-ui';
import { useTranslation, SUPPORTED_LANGS, LANG_LABELS } from '../../i18n';
import { getRoutesForLang } from '../../i18n/routes';

export default function AppNavbar() {
  const { t, lang, switchTo } = useTranslation();
  const prefix = `/${lang}`;
  const routes = getRoutesForLang(lang);

  const navLinks = [
    { label: t.nav.howItWorks, to: `${prefix}${routes['how-it-works']}` },
    { label: t.nav.useCases, to: `${prefix}${routes['use-cases']}` },
    { label: t.nav.pricing, to: `${prefix}${routes.pricing}` },
    { label: t.nav.blog, to: `${prefix}/blog` },
  ];

  return (
    <Navbar
      logo={{
        light: '/images/icons/aletiq-logo.svg',
        dark: '/images/icons/aletiq-logo-white.svg',
        alt: 'aletiq',
        width: 120,
      }}
      brandName="Aletiq"
      homeLink={prefix}
      links={navLinks}
      languageSwitch={{
        current: lang,
        options: SUPPORTED_LANGS.map((code) => ({
          code,
          label: LANG_LABELS[code],
          onSelect: () => switchTo(code),
        })),
      } satisfies NavLanguageDropdown}
      cta={{ label: t.nav.cta, to: `${prefix}${routes.pricing}` }}
    />
  );
}
